import { useTranslation } from 'react-i18next'

export default function useNavLinks(pathname) {
  const [t] = useTranslation()
  const helpAndLearningLinks = [
    {
      path: '/helpcenter/landing',
      name: t('help.tab.help-and-learning', 'Help and Learning'),
      index: 0,
      external: false,
      dataTestId: 'helpAndLearningNav',
    },
    {
      path: '/helpcenter/classes-and-videos',
      name: t('help.tab.classes-and-videos', 'Classes and Videos'),
      index: 1,
      external: false,
      dataTestId: 'classesAndVideosNav',
    },
    {
      path: '/helpcenter/community-landing',
      name: t('help.tab.community', 'Community'),
      index: 2,
      external: false,
      dataTestId: 'communityNav',
    },
    {
      path: '/helpcenter/one-on-one',
      name: t('help.tab.one-on-one', 'One-on-One Help'),
      index: 3,
      external: false,
      dataTestId: 'oneOnOneNav',
    },
  ]
  if (helpAndLearningLinks.some((link) => link.path === pathname)) return helpAndLearningLinks
  return []
}
